import { Component } from '@angular/core';
import { MonitorComponent } from '../../monitor.component';
import { MonitorEndpointsService } from '../../../common';
import { tokenIntvertColorFlashAnimation } from '../../../common/common.animation';

// Angular does not inherit `providers`/`animations` from a parent @Component, so each
// monitor view must re-declare them to keep the flash animation working consistently.
@Component({
  selector: 'app-monitor-vrt',
  templateUrl: './monitor-vrt.component.html',
  styleUrls: ['./monitor-vrt.component.scss'],
  providers: [MonitorEndpointsService],
  animations: [tokenIntvertColorFlashAnimation()],
})
export class MonitorVrtComponent extends MonitorComponent {}
